/* eslint-disable arrow-body-style */
import React from 'react';
import { ButtonAction, Modal } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';

import './CloseModal.scss';

export interface Props {
  isOpen: boolean;
  closeModalClose: () => void;
}

const CloseModal = ({ isOpen, closeModalClose }: Props) => {
  return (
    <Modal
      closeModal={closeModalClose}
      closeOnClick
      isCentered
      id="close-modal"
      isOpen={isOpen}
      className="close-modal"
    >
      <>
        <h1 id="close-modal-heading" className="close-modal__heading">
          {content.closeModal.heading}
        </h1>
        <p className="close-modal__content">{content.closeModal.content}</p>
        <ButtonAction
          id="close-modal-yes-button"
          className="close-modal__button-yes"
          href={content.closeModal.goToHomePageUrl}
          variant="default"
        >
          {content.closeModal.yesBtnText}
        </ButtonAction>
        <ButtonAction
          id="close-modal-no-button"
          className="close-modal__button-no"
          onClick={closeModalClose}
          variant="default"
        >
          {content.closeModal.noBtnText}
        </ButtonAction>
      </>
    </Modal>
  );
};

export default CloseModal;
